import { type FC } from 'react';
import {
  Hourglass
} from '@phosphor-icons/react';
import { UiIcon, type UiIconProps } from './UiIcon';

export type UiIconHourGlassProps = Omit<UiIconProps, 'IconComponent'>;

export const UiIconHourGlass: FC<UiIconHourGlassProps> = (props) => {
  return (
    <UiIcon
      IconComponent={Hourglass}
      {...props}
    />
  );
};
